import { Form, Input, message, Modal } from "antd";
import { Rule } from "antd/lib/form";
import { staffApi } from "api/staff.api";
import React, { useImperativeHandle, useState } from "react";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true }];

export interface ResetPasswordModal {
  handleCreate: (Staff: Staff) => void;
}
interface ResetPasswordModalProps {
  onClose: () => void;
  onSubmitOk: () => void;
}

export const ResetPasswordModal = React.forwardRef(
  ({ onClose, onSubmitOk }: ResetPasswordModalProps, ref) => {
    const [form] = Form.useForm<{ password: string }>();
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState<Staff>();

    useImperativeHandle<any, ResetPasswordModal>(
      ref,
      () => ({
        handleCreate(Staff: Staff) {
          form.resetFields();
          setVisible(true);
          setSelectedStaff(Staff);
        },
      }),
      [],
    );

    const handleSubmit = async () => {
      await form.validateFields();
      const data = { newPassword: form.getFieldValue("password") };

      setLoading(true);
      try {
        await staffApi.resetPassword(selectedStaff?.id || 0, data);
        message.success("Reset mật khẩu thành công");
        handleClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const handleClose = () => {
      setVisible(false);
      setSelectedStaff(undefined);
      onClose();
    };

    return (
      <Modal
        onCancel={handleClose}
        open={visible}
        title={"Reset mật khẩu"}
        style={{ top: 20 }}
        width={500}
        confirmLoading={loading}
        cancelText="Đóng"
        onOk={handleSubmit}
      >
        <Form layout="vertical" form={form}>
          <Form.Item label="Mật khẩu mới" required name="password" rules={rules}>
            <Input.Password placeholder="" />
          </Form.Item>
        </Form>
      </Modal>
    );
  },
);
